angular.module("kitstajm").service("Modal", function ($uibModal) {
  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: "./partial/modal.html",
  };

  var modalOptions = {
    closeButtonText: "Close",
    actionButtonText: "OK",
    headerText: "Proceed?",
    bodyText: "Perform this action?",
  };

  this.showModal = function (customModalDefaults, customModalOptions) {
    if (!customModalDefaults) {
      customModalDefaults = {};
    }
    customModalDefaults.backdrop = "static";
    customModalDefaults.keyboard = false;

    return this.show(customModalDefaults, customModalOptions);
  };

  this.show = function (customModalDefaults, customModalOptions) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {};

    //Map angular-ui modal custom defaults to modal defaults defined in service
    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

    //Map modal.html $scope custom properties to defaults defined in service
    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = [
        "$scope",
        "$uibModalInstance",
        function ($scope, $uibModalInstance) {
          $scope.modalOptions = tempModalOptions;

          // Initiera zoom-state
          $scope.modalOptions.zoomedImage = null;
          $scope.modalOptions.zoomedIndex = null;
          $scope.modalOptions.zoomLevel = 1;

          // Öppna zoom
          $scope.modalOptions.zoomImage = function (imgUrl) {
            const index = $scope.modalOptions.expense.receipts.findIndex(r => r.data === imgUrl);
            $scope.modalOptions.zoomedIndex = index;
            $scope.modalOptions.zoomedImage = imgUrl;
            $scope.modalOptions.zoomLevel = 1;
            document.body.style.overflow = 'hidden'; // 🔒 stoppa scroll
          };

          // Stäng zoom
          $scope.modalOptions.closeZoom = function () {
            $scope.modalOptions.zoomedImage = null;
            $scope.modalOptions.zoomedIndex = null;
            $scope.modalOptions.zoomLevel = 1;
            document.body.style.overflow = ''; // 🔓 återställ scroll
          };

          // Växla zoom-nivå
          $scope.modalOptions.toggleZoomLevel = function ($event) {
            $event.stopPropagation();
            $scope.modalOptions.zoomLevel = $scope.modalOptions.zoomLevel === 1 ? 2 : 1;
          };

          // Nästa bild
          $scope.modalOptions.nextImage = function ($event) {
            $event.stopPropagation();
            const next = $scope.modalOptions.zoomedIndex + 1;
            if (next < $scope.modalOptions.expense.receipts.length) {
              $scope.modalOptions.zoomedIndex = next;
              $scope.modalOptions.zoomedImage = $scope.modalOptions.expense.receipts[next].data;
              $scope.modalOptions.zoomLevel = 1;
            }
          };

          // Föregående bild
          $scope.modalOptions.prevImage = function ($event) {
            $event.stopPropagation();
            const prev = $scope.modalOptions.zoomedIndex - 1;
            if (prev >= 0) {
              $scope.modalOptions.zoomedIndex = prev;
              $scope.modalOptions.zoomedImage = $scope.modalOptions.expense.receipts[prev].data;
              $scope.modalOptions.zoomLevel = 1;
            }
          };

          // Tangentbordsnavigering
          $scope.handleKeyDown = function (event) {
            if ($scope.modalOptions.zoomedImage) {
              switch (event.key) {
                case 'Escape':
                  event.preventDefault();
                  event.stopPropagation();
                  $scope.modalOptions.closeZoom();
                  $scope.$apply();
                  break;
                case 'ArrowRight':
                  $scope.modalOptions.nextImage({ stopPropagation: () => { } });
                  $scope.$apply();
                  break;
                case 'ArrowLeft':
                  $scope.modalOptions.prevImage({ stopPropagation: () => { } });
                  $scope.$apply();
                  break;
              }
            } else if (event.key === 'Escape') {
              $scope.modalOptions.close();
              $scope.$apply();
            }
          };

          document.addEventListener('keydown', $scope.handleKeyDown);

          $scope.$on('$destroy', function () {
            document.removeEventListener('keydown', $scope.handleKeyDown);
            document.body.style.overflow = ''; // 🔄 säkerställ scroll återställs
          });


          $scope.modalOptions.ok = function (result) {
            $uibModalInstance.close(result);
          };
          $scope.modalOptions.close = function () {
            $uibModalInstance.dismiss("cancel");
          };
        },
      ];
    }
    return $uibModal.open(tempModalDefaults).result;
  };
});
